"use client";

import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React from "react";

import { cn } from "@/lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      // Base layout
      "peer inline-flex h-6 w-10 shrink-0 cursor-pointer items-center rounded-full shadow",
      // Border
      "border-2 border-transparent",
      // Transitions
      "transition-colors",
      // Focus states
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
      // Disabled states
      "disabled:cursor-not-allowed disabled:opacity-50",
      // State-based colors
      "data-[state=checked]:bg-accent data-[state=unchecked]:bg-bg-tertiary",
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        // Base layout
        "pointer-events-none block h-4 w-4 rounded-full bg-background shadow",
        // Visual effects
        "shadow-lg ring-0",
        // Transitions
        "transition-transform",
        // State-based positioning
        "data-[state=checked]:-translate-x-0.5 data-[state=unchecked]:-translate-x-4.5 data-[state=unchecked]:bg-surface",
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
